import { Badge } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { ContractStatus } from "../../../../../types/neWebApi.types";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import { DATE_DISPLAY_FORMAT } from "../../../../../utils/dates/dates.constants";
import type { PPAContract } from "../../PPAContractPage.types";

const STATUS_LABELS: Record<ContractStatus, string> = {
  [ContractStatus.active]: "Aktiv",
  [ContractStatus.expired]: "Abgelaufen / außer Kraft",
  [ContractStatus.terminated]: "Gekündigt",
  [ContractStatus.upcoming]: "Anstehend"
};

const STATUS_COLOURS: Record<ContractStatus, string> = {
  [ContractStatus.active]: "success",
  [ContractStatus.expired]: "neutral",
  [ContractStatus.terminated]: "error",
  [ContractStatus.upcoming]: "blue"
};

export function getStatusColumn(): MRT_ColumnDef<PPAContract> {
  return {
    accessorKey: "status",
    accessorFn: (row) => STATUS_LABELS[row.status],
    header: "Status",
    size: 220,
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: Object.values(STATUS_LABELS)
    },
    sortingFn: (rowA, rowB) => {
      const statusOrder = [
        ContractStatus.active,
        ContractStatus.upcoming,
        ContractStatus.terminated,
        ContractStatus.expired
      ];

      return (
        statusOrder.indexOf(rowA.original.status) -
        statusOrder.indexOf(rowB.original.status)
      );
    },
    Cell: ({ row }) => (
      <Badge
        color={STATUS_COLOURS[row.original.status]}
        radius="sm"
        variant="outline"
      >
        {getStatusText(
          row.original.status,
          row.original.confirmed_termination_date
        )}
      </Badge>
    )
  };
}

function getStatusText(
  status: ContractStatus,
  confirmedTerminationDate?: string | null
) {
  if (status === ContractStatus.terminated && confirmedTerminationDate) {
    const confirmedTerminationDateText =
      backendDateOrDateTimeToLuxonDateTimeOrNull(
        confirmedTerminationDate
      )?.toFormat(DATE_DISPLAY_FORMAT);

    return `${STATUS_LABELS[status]} zum ${confirmedTerminationDateText}`;
  }

  return STATUS_LABELS[status];
}
